import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone } from 'lucide-react';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  }, [location]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    document.body.style.overflow = menuOpen ? '' : 'hidden';
  };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar-inner">
          <Link to="/" className="nav-logo">
            <div className="nav-logo-icon">PDI</div>
            <span>PDI Care</span>
          </Link>

          <div className="nav-phone">
            <Phone size={16} />
            <a href="tel:8186265240">(818) 626-5240</a>
          </div>

          <ul className="nav-links">
            <li><Link to="/" className={isActive('/')}>Home</Link></li>
            <li><Link to="/services" className={isActive('/services')}>Services</Link></li>
            <li><Link to="/insurances" className={isActive('/insurances')}>Insurance</Link></li>
            <li><Link to="/order-exam" className={isActive('/order-exam')}>Contact</Link></li>
          </ul>

          <div className="nav-cta">
            <Link to="/contact" className="btn btn-primary">
              Order Exam
            </Link>
          </div>

          <button
            className={`menu-toggle ${menuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <div className={`mobile-nav-overlay ${menuOpen ? 'open' : ''}`}>
        <Link to="/" className={isActive('/')}>Home</Link>
        <Link to="/services" className={isActive('/services')}>Services</Link>
        <Link to="/insurances" className={isActive('/insurances')}>Insurance</Link>
        <Link to="/order-exam" className={isActive('/order-exam')}>Contact</Link>
        <Link to="/contact" className="btn btn-primary" style={{ marginTop: '16px' }}>
          Order Exam
        </Link>
        <div className="mobile-nav-contact">
          <a href="tel:8186265240">(818) 626-5240</a>
          <a href="mailto:exams@pdicare.com">exams@pdicare.com</a>
        </div>
      </div>
    </>
  );
}

export default Navbar;
